export default {
  getSoftSaleStockItem: (state) => state.softSaleStockItem,
};
